<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row>
      <el-col :sm="12">
        <h4 class="form-title">Repair - Masterlist</h4>
      </el-col>
      <el-col :sm="12">
        <div class="d-flex justify-content-flex-end">
          <el-input
            class="input-start"
            placeholder="Search ULD ID Code"
            v-model="pager.search_key"
            @keydown.native.enter="fetch(1)"
          >
          </el-input>
          <el-input
            class="input-end"
            placeholder="Search TSO Ser No."
            v-model="pager.search_key_tso"
            @keydown.native.enter="fetch(1)"
          >
          </el-input>
          <el-button
            v-if="!user.isRole([2])"
            type="primary"
            size="small"
            @click="$refs.masterlistForm.open()"
            class="ml-2"
          >
            Add Masterlist
          </el-button>
        <el-button size="small" type="primary" @click="download" >Download Masterlist</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="data.data">
          <el-table-column label="Actions" width="100">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                title="Edit information"
                circle
                size="small"
                @click="$refs.masterlistForm.open(scope.row.id)"
              ></el-button>
              <el-button
                size="small"
                type="danger"
                icon="el-icon-delete"
                @click="removeMasterlist(scope.row.id)"
                title="Remove Masterlist. "
                v-if="user.isRole([1])"
                circle
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="ULD ID Code"
            prop="uld_id_code"
          ></el-table-column>
          <el-table-column
            label="TSO Ser No."
            prop="tso_ser_no"
          ></el-table-column>
          <el-table-column
            label="Manufacturer"
            prop="manufacturer_name"
          ></el-table-column>
          <el-table-column label="Date" prop="rev_date">
            <template slot-scope="scope">
              {{ scope.row.manuf_date | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column
            label="ULD Part No."
            prop="jo_part"
          ></el-table-column>
          <el-table-column
            label="Old ID Code"
            prop="old_number_code"
          ></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-pagination
      v-show="!isLoading"
      class="pt-1 pb-1"
      background
      layout="prev, pager, next"
      :total="data.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(data.paging.cur_page)"
      @current-change="fetch"
    >
    </el-pagination>
    <el-row class="mt-1">
      <el-col>
        <el-upload
          v-if="!user.isRole([2])"
          :action="api.href"
          :file-list="fileList"
          accept=".csv"
          :headers="api.headers"
          :on-success="handleSuccess"
          :show-file-list="false"
        >
          <el-button type="primary" icon="el-icon-upload" size="small"
            >Upload Renumbering</el-button
          >
        </el-upload>
      </el-col>
      <el-col>
        <AppUploader
          v-if="!user.isRole([2])"
          class="mt-1"
          url="/api/v1/repair/upload_masterlist/masterlist/"
          accept=".csv"
          @beforeUpload="beforeUpload"
          @uploadSuccess="batch_handleUploadSuccess"
          >Batch Upload</AppUploader
        >
      </el-col>
    </el-row>
    <MasterlistForm ref="masterlistForm" @fetchList="fetch(1)" />
  </div>
</template>

<script>
import moment from "moment";
import api from "@/api";

// import CMM from "@/models/CMM";
import Manufacturer from "@/models/Manufacturer";
import Masterlist from "@/models/Masterlist";
// import SpareParts from "@/models/SpareParts";

import MasterlistForm from "./Masterlist/masterlistForm.vue";
export default {
  name: "Masterlist",
  components: { MasterlistForm },
  beforeRouteLeave(to, from, next) {
    if (this.isLoading) alert("You have unsaved changes.");
    else next();
  },
  data() {
    return {
      formModel: new Masterlist(),
      // spareParts: [],
      manufacturers: [],
      // cmms: [],
      rules: {
        manufacturer_id: [
          { required: true, message: "Manufacturer is required." }
        ],
        jo_part_id: [{ required: true, message: "Spare Part is required." }],
        tso_ser_no: [{ required: true, message: "TSO Ser No. is required." }],
        manuf_date: [
          { required: true, message: "Manufacturing date is required." }
        ],
        owner: [{ required: true, message: "Owner is required." }],
        type: [{ required: true, message: "Type is required." }],
        description: [{ required: true, message: "Description is required." }],
        uld_id_code: [{ required: true, message: "Code is required." }]
      },
      data: { paging: {}, data: [] },
      isLoading: false,
      pager: {
        limit: 15,
        search_key: "",
        search_key_tso: ""
      },
      viewDrawer: false,
      descriptions: Masterlist.descriptions(),
      fileList: []
    };
  },
  computed: {
    api() {
      return {
        headers: {
          // "Content-Type": "multipart/form-data",
          Authorization: `${this.$store.getters["auth/token"].token_type} ${this.$store.getters["auth/token"].access_token}`,
          "X-Requested-With": "XMLHttpRequest"
        },
        href: new URL("/api/v1/repair/upload/masterlist/", api.baseUrl).href
      };
    },
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  methods: {
    fetch(page) {
      this.isLoading = true;
      let params = {};

      params.limit = 1
      if (page) {
        params.page = 3;
      }
      if (this.pager.search_key) {
        params.search = this.pager.search_key;
      }
      if (this.pager.search_key_tso) {
        params.search_tso = this.pager.search_key_tso;
      }

      Masterlist.list(params).then(list => {
        this.isLoading = false;
        if (list) this.data = list;
      });
    },
    download() {
      var reportInfo = {
          name: "Masterlist",
          ext: ".csv"
      };
      let url = `/api/v1/repair/masterlist/?limit=-1`
      api.download(url, reportInfo).then(() => {
          this.isLoading = false;
          this.btnDisable = false;
      });
    },
    edit(item) {
      this.viewDrawer = true;
      this.formModel = new Masterlist({
        id: item.id,
        jo_part_id: item.jo_part_id,
        manufacturer_id: item.manufacturer_id,
        tso_ser_no: item.tso_ser_no,
        manuf_date: item.manuf_date,
        owner: item.owner,
        type: item.type,
        description: item.description,
        uld_id_code: item.uld_id_code,
        cmm: item.cmm
      });
    },
    save() {
      this.$confirm("Do you want to save the Masterlist information?")
        .then(() => {
          this.$refs.form.validate(valid => {
            if (!valid) return false;
            this.isLoading = true;
            this.formModel.manuf_date = moment(
              this.formModel.manuf_date
            ).format("YYYY-MM-DD");
            if (this.formModel.id) {
              let payload = { ...this.formModel };
              delete payload._default;
              Masterlist.update(payload).then(resp => {
                if (resp.code == 200) {
                  this.$refs.drawer.closeDrawer();
                  this.formModel = new Masterlist();
                  this.fetch();
                  this.isLoading = false;
                  this.$notify({
                    type: "success",
                    message: "Repair Masterlist information saved.",
                    position: "bottom-right"
                  });
                }
              });
            } else {
              Masterlist.store(this.formModel).then(resp => {
                this.isLoading = false;
                if (resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "Repair Masterlist information saved.",
                    position: "bottom-right"
                  });
                  this.$refs.drawer.closeDrawer();
                  this.formModel = new Masterlist();
                  this.fetch();
                }
              });
            }
          });
        })
        .catch(() => {});
    },
    loadData() {
      // this.spareParts = [];
      // SpareParts.list({ limit: 99999 }).then(list => {
      //   this.spareParts = list.data;
      // });

      this.manufacturers = [];
      Manufacturer.list({ limit: 99999 }).then(list => {
        this.manufacturers = list.data;
      });

      // this.cmms = [];
      // CMM.list({ limit: 99999 }).then(list => {
      //   this.cmms = list.data;
      // });
    },
    handleSuccess(resp) {
      if (resp.data.errors && resp.data.errors.length != 0) {
        // console.error(resp.data.errors);
        this.$notify({
          type: "error",
          message:
            "Error encountered during processing of batch upload. Please see your browser console.",
          position: "bottom-right"
        });
      } else {
        if (resp.data.code == 200) {
          this.fetch();
          this.$notify({
            type: "success",
            message: "Masterlist renumbering success.",
            position: "bottom-right"
          });
        } else {
          this.$notify({
            type: "error",
            message: resp.data.msg,
            position: "bottom-right"
          });
        }
      }
    },
    viewDoc() {
      window.open(
        `/pdf-viewer/doc?type=cmm&id=${this.formModel.cmm.id}`,
        "_blank"
      );
    },
    beforeUpload() {
      this.isLoading = true;
    },
    batch_handleUploadSuccess(res) {
      this.isLoading = false;
      // console.log(res);
      if (
        res.hasOwnProperty("data") &&
        res.data.hasOwnProperty("code") &&
        res.data.code == 200
      ) {
        this.fetch();
        this.$notify({
          type: "success",
          message: res.data.msg,
          position: "bottom-right"
        });
      } else {
        this.$notify({
          type: "error",
          message: res.data.msg,
          position: "bottom-right"
        });
      }
    },
   removeMasterlist(id) {
    this.$confirm("Do you want to delete this Masterlist?")
      .then(() => {
        if (id) {
        let payload = { 
            status: 1,
            id: id
          };
          delete payload._default;
          Masterlist.update(payload).then(resp => {
            this.isLoading = false;
            if (resp.code == 200) {
              this.$notify({
                type: "success",
                message: "Masterlist Deleted.",
                position: "bottom-right"
              });
              this.fetch();
            }
          });
        }
      })
      .catch(() => {});
  }
  },

  created() {
    window.addEventListener("beforeunload", e => {
      if (this.isLoading) {
        e.preventDefault();
        event.returnValue = " ";
      }
    });
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .input-start .el-input__inner {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .input-end .el-input__inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
